import Ledger from "./Ledger";
import Horizon from "./Horizon";
import Column from "./Column";
import Bitmap from "./Bitmap";
import Haiku from "./Haiku";

const designs = { 1: Ledger, 2: Horizon, 3: Column, 4: Bitmap, 5: Haiku };

export default designs;
